import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import { AppContext } from "../../App";
import Loader from "../../components-utils/Loader";
import I18n from "../../components-utils/I18n";
import SalesInformationChoice from "./SalesInformationChoice";

import { getSalesInformation, saveSalesInformation } from "../../services/api";
import { validateObject, mandatory } from "../../services/validator";
import { loadItem } from "../../services/utils";

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";

import "./SalesInformation.css";

const informationTypes = [
  { code: "firstname", label: "Texte - Prénom" },
  { code: "lastname", label: "Texte - Nom" },
  { code: "age", label: "Nombre - Age" },
  { code: "divider" },
  { code: "text", label: "Texte" },
  { code: "number", label: "Nombre" },
  { code: "date", label: "Date" },
  { code: "select", label: "Sélection" }
];

const emptySalesInformation = (merchantCode, langs) => ({
  id: -1,
  merchantCode,
  value: {
    technicalLabel: "",
    type: "text",
    i18n: { fr: emptyI18n() }
  },
  rank: 0
});
const emptyI18n = isSelect => ({
  label: "",
  description: "",
  values: isSelect ? [] : undefined
});

class SalesInformation extends Component {
  state = {
    lang: "fr",
    errors: {}
  };

  async componentDidMount() {
    const result = await loadItem(
      this.props,
      getSalesInformation,
      emptySalesInformation
    );
    if (result !== undefined) {
      this.setState({
        salesInformation: result.item,
        merchantCode: result.merchantCode
      });
    }
  }

  modifyI18n = (field, modifyAction, callback) => {
    this.setState(
      state => ({
        salesInformation: {
          ...state.salesInformation,
          value: {
            ...state.salesInformation.value,
            i18n: {
              ...state.salesInformation.value.i18n,
              [state.lang]: {
                ...state.salesInformation.value.i18n[state.lang],
                [field]:
                  typeof modifyAction === "function"
                    ? modifyAction()
                    : modifyAction
              }
            }
          }
        }
      }),
      callback !== undefined ? callback() : undefined
    );
  };

  changeFields = name => e => {
    const { lang } = this.state;
    const value = e.target.value;
    this.modifyI18n(
      name,
      value,
      lang === "fr" && name === "label"
        ? () => {
            this.setState(state => ({
              salesInformation: {
                ...state.salesInformation,
                value: {
                  ...state.salesInformation.value,
                  technicalLabel: value
                }
              }
            }));
          }
        : undefined
    );
  };

  changeType = e => {
    this.setState(state => ({
      salesInformation: {
        ...state.salesInformation,
        value: { ...state.salesInformation.value, type: e.target.value }
      }
    }));
  };
  changeLang = lang => {
    this.setState({ lang });
  };

  removeFunction = (values, idx) => () => values.filter((v, i) => i !== idx);
  removeChoice = index => () => {
    const {
      salesInformation: {
        value: { i18n }
      },
      lang
    } = this.state;
    this.modifyI18n("values", this.removeFunction(i18n[lang].values, index));
  };
  addFunction = (values, newValue) => () =>
    values.concat({ key: newValue, value: newValue });
  addChoice = newValue => {
    const {
      salesInformation: {
        value: { i18n }
      },
      lang
    } = this.state;
    const values = i18n[lang].values;
    this.modifyI18n(
      "values",
      this.addFunction(values !== undefined ? values : [], newValue)
    );
  };

  reorderFunction = (values, source, target, position) => () => {
    const sourceObj = values[source];
    const targetObj = values[target];

    return values.reduce(
      (acc, value, index) =>
        index === source
          ? acc
          : index === target
          ? position === "before"
            ? [...acc, sourceObj, targetObj]
            : [...acc, targetObj, sourceObj]
          : [...acc, value],
      []
    );
  };
  reorderChoice = (source, target, position) => {
    const {
      salesInformation: {
        value: { i18n }
      },
      lang
    } = this.state;
    this.modifyI18n(
      "values",
      this.reorderFunction(i18n[lang].values, source, target, position)
    );
  };

  labelValidators = this.props.langs.reduce(
    (acc, lang) => ({ ...acc, [lang.code]: { label: [mandatory] } }),
    {}
  );

  saveProductUnavailabilities = () => {
    const { salesInformation } = this.state;
    const i18n = salesInformation.value.i18n;
    const errors = validateObject(i18n, this.labelValidators);

    this.setState({ errors }, () => {
      const { errors, salesInformation, merchantCode } = this.state;
      const {
        match: {
          params: { id }
        },
        langs
      } = this.props;
      if (errors === undefined || (id === "new" && errors.fr === undefined)) {
        const { snackbar, history } = this.props;
        if (merchantCode !== undefined) {
          const salesInformationToSave =
            id === "new"
              ? {
                  ...salesInformation,
                  value: {
                    ...salesInformation.value,
                    i18n: langs.reduce(
                      (acc, lang) => ({
                        ...acc,
                        [lang.code]: salesInformation.value.i18n.fr
                      }),
                      {}
                    )
                  }
                }
              : salesInformation;

          saveSalesInformation(id, merchantCode, salesInformationToSave)
            .then(salesInformation => {
              this.setState({ salesInformation }, () => {
                history.push(`/sales-informations/${salesInformation.id}`);
                snackbar("Informations enregistrées");
              });
            })
            .catch(e => {
              console.log(e);
              snackbar(
                "Erreur pendant la sauvegarde. Veuillez réessayer",
                "error"
              );
            });
        }
      }
    });
  };
  renderLoader() {
    return <Loader loading={true} />;
  }
  renderI18n() {
    const { langs } = this.props;
    const { lang, salesInformation, errors } = this.state;
    const i18n = salesInformation.value.i18n[lang];
    const type = salesInformation.value.type;
    return (
      <I18n
        langs={langs}
        lang={lang}
        changeFields={this.changeFields}
        changeLang={this.changeLang}
        elements={salesInformation.value.i18n}
        emptyElement={emptyI18n(type === "select")}
        errors={errors}
        onlyFr={salesInformation.id === -1}
        className="sp-unavailability--i18n"
      >
        {type === "select" && (
          <SalesInformationChoice
            values={
              i18n !== undefined && i18n.values !== undefined ? i18n.values : []
            }
            removeChoice={this.removeChoice}
            addChoice={this.addChoice}
            reorderChoice={this.reorderChoice}
          />
        )}
      </I18n>
    );
  }
  render() {
    const { salesInformation } = this.state;

    return salesInformation !== undefined ? (
      <Card key="page">
        <CardContent>
          <Typography variant="h4">
            {salesInformation.value.technicalLabel !== ""
              ? salesInformation.value.technicalLabel
              : "Nouvelle Valeur"}
          </Typography>
          <TextField
            label="Type d'information"
            select
            margin="normal"
            value={salesInformation.value.type}
            onChange={this.changeType}
            fullWidth
          >
            {informationTypes.map(type =>
              type.code !== "divider" ? (
                <MenuItem key={type.code} value={type.code}>
                  {type.label}
                </MenuItem>
              ) : (
                <Divider key="divider" />
              )
            )}
          </TextField>

          {this.renderI18n()}
        </CardContent>
        <CardActions className="sp-unavailability--actions">
          <Button
            variant="contained"
            color="secondary"
            onClick={this.saveProductUnavailabilities}
          >
            Valider
          </Button>
        </CardActions>
      </Card>
    ) : (
      this.renderLoader()
    );
  }
}

const enhanced = WrappedComponent => props => {
  return (
    <AppContext.Consumer>
      {app => (
        <WrappedComponent
          {...props}
          snackbar={app.snackbar.open}
          langs={app.langs}
        />
      )}
    </AppContext.Consumer>
  );
};

export default withRouter(enhanced(SalesInformation));



// WEBPACK FOOTER //
// ./src/components/sales-informations/SalesInformation.js